export default __webpack_public_path__ + "static/media/accountIntent3.22.9945a9cc.png";